import { render } from "./dyColonelAwardTaskManage.vue?vue&type=template&id=0336a755"
import script from "./dyColonelAwardTaskManage.vue?vue&type=script&lang=js"
export * from "./dyColonelAwardTaskManage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__